import { SearchTypeahead } from '@bambi/component-library/src/components/SearchTypeahead/SearchTypeahead';

import { useAppSelector } from 'src/app/store/hooks';
import { useDebouncedSearch } from 'src/common/useDebouncedSearch';

import { setUnassignedTripsSearchTerm } from '../../dispatcher.slice';

export function UnassignedTripSearch() {
  const unassignedTripsSearchTerm = useAppSelector(
    (state) => state.dispatcher.unassignedTripsSearchTerm
  );

  const { inputValue, handleInputChange } = useDebouncedSearch(
    setUnassignedTripsSearchTerm,
    unassignedTripsSearchTerm
  );

  return (
    <>
      <SearchTypeahead
        placeholder="Search unassigned trips"
        onChange={handleInputChange}
        value={inputValue}
      />
    </>
  );
}
